const asyncActionType = type => ({
    pending: `${type}_PENDING`,
    success: `${type}_SUCCESS`,
    error: `${type}_ERROR`
});

export const LOAD_INQUIRIES = asyncActionType('LOAD_INQUIRIES');
export const DELETE_INQUIRIES=asyncActionType('DELETE_INQUIRIES');
export const DOWNLOAD_HISTORIC_DATA=asyncActionType('DOWNLOAD_HISTORIC_DATA');


